import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { NinetyNotification } from '../models/ninety-notification.model';
import { NotificationFilterOptions } from '../models/notification-filter-options';

export const NotificationFeedStateKey = 'page-notification-feed';

export interface NotificationFeedStateModel extends EntityState<NinetyNotification> {
  currentPage: number;
  hasMore: boolean;
  filterBy: NotificationFilterOptions;
}

export const notificationFeedAdapter = createEntityAdapter<NinetyNotification>({
  selectId: notification => notification.id,
});

export const initialNotificationFeedState: NotificationFeedStateModel = notificationFeedAdapter.getInitialState({
  currentPage: 1,
  hasMore: true,
  filterBy: NotificationFilterOptions.all,
});
